<template>
    <side-container v-if="visible"
        :width="500"
        :headerTitle="headerTitle"
        :isShowFooterBtn="false"
        :isLoading="isLoading"
        @close="$emit('update:visible', false)">
        <!-- body -->
        <div class="body">
            <!-- 个人信息 -->
            <h2 class="title">个人信息</h2>
            <div class="info-wrapper">
                <div class="info-item">
                    <span class="des">真实姓名：</span>
                    <span v-textPopper
                        class="result text-popper">{{ staffInfoForm.realname || '未设置' }}</span>
                </div>
                <div class="info-item">
                    <span class="des">微信信息：</span>
                    <user-info 
                    :userInfo="staffInfoForm.weixinInfo"
                    :width="'160px'"/>
                </div>
            </div>
            <div class="info-wrapper">
                <div class="info-item">
                    <span class="des">手机号码：</span>
                    <span class="result">{{ staffInfoForm.phone || '未设置' }}</span>
                </div>
                <div class="info-item">
                    <span class="des">员工生日：</span>
                    <span class="result">{{ staffInfoForm.birthday || '未设置' }}</span>
                </div>
            </div>
            <div class="info-wrapper">
                <div class="info-item">
                    <span class="des">员工职位：</span>
                    <el-input
                        v-model="staffInfoForm.position"
                        placeholder="请输入员工职位"
                        maxlength="10"
                        :show-word-limit="true"/>
                </div>
                <div class="info-item">
                    <span class="des">入职时间：</span>
                    <el-date-picker
                        v-model="formatEntryTime"
                        type="date"
                        placeholder="请选择入职时间"/>
                </div>
            </div>
            <div class="info-remark">
                <span class="des">备&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;注：</span>
                <el-input
                    v-model="staffInfoForm.remarks"
                    placeholder="请输入备注信息"
                    maxlength="20"
                    :show-word-limit="true"/>
            </div>
            <!-- 配置角色和权限
            <h2 class="title">配置角色和权限</h2>
            <div class="role-config fx-v-center">
                <span class="des">配置角色：</span>
                <el-select v-model="selectedVal"
                    ref="elSelect"
                    :disabled="isCanNotEditSuperPermission"
                    @change="elSelectChange"
                    @click.native="elSelectClick">
                    <el-option
                        v-for="(item, index) in selectOptions"
                        :key="item.value + index"
                        :label="item.label"
                        :value="item.value"/>
                    <div class="el-append-item">
                        <span class="href"
                            @click="addRole">添加角色</span>
                    </div>
                    <div class="el-append-item"
                        slot="empty">
                        <span class="href"
                            @click="addRole">添加角色</span>
                    </div>
                </el-select>
            </div>
            <p v-if="isShowSuperAdminTips"
                class="color-red fs-12"
                style="padding: 10px 0 0 70px">超管权限不可编辑</p>
            <div v-if="isShowRolePermission"
                class="role-permission fx">
                <span class="des mt-12">角色权限：</span>
                <role-permission :justifyContent="'flex-start'"
                    :permissionList="permissionList"/>
            </div> -->
        </div>
        <!--  footer  -->
        <div
            class="footer"
            slot="footer">
            <div
                class ="btn-wrapper"
                :class="mode">
                <el-button
                    plain
                    size="medium"
                    type="danger" 
                    v-if="mode === 'update'"
                    :loading="isDeleteLoading"
                    @click="deleteClick"
                >删除</el-button>
                <el-button
                    size="medium"
                    type="primary"
                    :loading="isConfirmLoading"
                    :disabled="!canConfirm"
                    @click="confirmClick"
                >确认</el-button>
            </div>
        </div>
        <!-- components -->
        <edit-and-add-staff-role :mode="'create'"
            :roleNameMap="roleNameMap"
            :roleInfo="curRoleInfo"
            :visible.sync="isShowEditAndAddStaffRole"
            :confirmCallback="() => $router.push('/main/staff/permissionSet')"/>
    </side-container>
</template>

<script lang='tsx'>
import { createComponent, ref, reactive, computed, watch, SetupContext } from '@vue/composition-api'
import SideContainer from "@/components/layout/side-container-style2.vue"
import RolePermission from '@/components/role_permission/role_permission.vue'
import EditAndAddStaffRole from '../permission_set/modules/edit_and_add_staff_role.vue'
import clone from 'lodash/cloneDeep'
import { openMessage, openWarning } from '../../../utils/system'
import $fetch from '@/api/index'
import dayjs from 'dayjs'
import { PermissionSetInterface } from '../permission_set/permission_set.vue'

interface Permission {
    label: string,
    value: number
}

interface StaffInfoInterface {
    creator_name: string,
    entry_date: string,
    id: number,
    permission_list: number[],
    permission_set: PermissionSetInterface,
    position: string,
    remarks: string,
    shop: number,
    status: number
}

export default createComponent({
    props: {
        visible: {
            type: Boolean,
            required: true
        },
        mode: {
            type: String,
            required: true
        },
        staffId: {
            type: Number
        },
        applyInfo: {
            type: Object
        },
        confirmCallback: {
            type: Function
        },
        deleteCallback: {
            type: Function
        }
    },

    setup: (
        props: {
            visible: boolean,
            mode: string,
            staffId: number,
            applyInfo: { [propName: string]: any },
            confirmCallback?: () => void,
            deleteCallback?: () => void
        },
        ctx: SetupContext
    ) => {
        const isShowEditAndAddStaffRole = ref(false)
        const isLoading = ref(false)
        const isConfirmLoading = ref(false)
        const isDeleteLoading = ref(false)
        const isShowSuperAdminTips = ref(false)
        const roleNameMap = ref<string[]>([])
        const permissionList = ref<number[]>([])
        const permissionSet = ref<PermissionSetInterface[]>([])
        const selectOptions = ref<Permission[]>([])
        const selectedVal = ref<number>()
        const staffInfoForm = ref<{ [propName: string]: any }>({
            realname: '',
            phone: '',
            birthday: '',
            position: '',
            entry_date: '',
            remarks: '',
            weixinInfo: {}
        })
        const curRoleInfo = ref<PermissionSetInterface>({
            id: 0,
            name: '',
            permission_list: [1, 2],
            permissions: 0
        })
        const curStaffInfo = ref<StaffInfoInterface>({})
        const store = ctx.root.$store
        let initSelectedVal

        watch(() => props.visible, (newVal) => {
            if (newVal) {
                // 弹窗被打开
                roleNameMap.value = []
                permissionList.value = []
                permissionSet.value = []
                isShowSuperAdminTips.value = false
                selectedVal.value = undefined
                initSelectedVal = undefined
                if (props.mode === "create") {
                    selectOptions.value = [{
                        label: '暂不选择',
                        value: 0
                    }]
                    staffInfoForm.value = {
                        realname: props.applyInfo.realname,
                        phone: props.applyInfo.phone,
                        birthday: props.applyInfo.birthday,
                        weixinInfo: props.applyInfo,
                        position: '',
                        entry_date: '',
                        remarks: ''
                    }
                    isLoading.value = true
                    getPermissionsetList()
                        .then(() => isLoading.value = false)
                } else {
                    isLoading.value = true
                    Promise.all([getStaffInfo(), getPermissionsetList()])
                        .then(() => {
                            // if (curStaffInfo.value.permission_list.includes(0)) {
                            //     // 超管
                            //     selectOptions.value = [{
                            //         label: curStaffInfo.value.permission_set.name,
                            //         value: curStaffInfo.value.permission_set.id
                            //     }].concat(selectOptions.value)
                            // } else {
                            //     selectOptions.value = [{
                            //         label: '暂不选择',
                            //         value: 0
                            //     }].concat(selectOptions.value)
                            // }
                            // const selectedValue = selectOptions.value.find((item) => item.value === selectedVal.value)
                            // if (selectedValue == null) {
                            //     selectedVal.value = initSelectedVal = undefined
                            // }
                            isLoading.value = false
                        })
                }
            }
        })

        const headerTitle = computed(() => {
            switch (props.mode) {
                case 'create':
                    return '添加员工'
                case 'update':
                    return '编辑员工信息'
                default:
                    return '未知标题'
            }
        })

        const isCanNotEditSuperPermission = computed(() => {
            return curStaffInfo.value.permission_list && curStaffInfo.value.permission_list.includes(0)
        })

        const isShowRolePermission = computed(() => {
            const selectedResult = selectOptions.value.find((item) => item.value === selectedVal.value)
            return selectedResult != null && selectedResult.value !== 0
        })

        const formatEntryTime = computed({
            get() {
                return staffInfoForm.value.entry_date
            },

            set(newVal: Date) {
                if (newVal) {
                    staffInfoForm.value.entry_date = dayjs(newVal).format('YYYY-MM-DD')
                } else {
                    staffInfoForm.value.entry_date = ''
                }
            }
        })

        const canConfirm = computed(() => {
            return true
        })

        function addRole() {
            (ctx.refs.elSelect as any).blur()
            curRoleInfo.value = {
                id: 0,
                name: '',
                permission_list: [],
                permissions: 0
            }
            isShowEditAndAddStaffRole.value = true
        }

        function elSelectChange(newVal) {
            if (store.state.shop.staffInfo.id === props.staffId) {
                selectedVal.value = initSelectedVal
                return openMessage('error', '无法更改自己的角色，请联系超管更改')
            }
            if (!store.getters['shop/canIUse'](8)) {
                selectedVal.value = initSelectedVal
                return openMessage('error', '暂无编辑/配置角色权限，请联系超管开启')
            }
            const selectedPermissionSet = permissionSet.value.find((item) => item.id === selectedVal.value)
            if (selectedPermissionSet != null) {
                permissionList.value = selectedPermissionSet.permission_list
            } else {
                permissionList.value = []
                selectedVal.value = undefined
            }
        }

        function elSelectClick() {
            if (!isShowSuperAdminTips.value && curStaffInfo.value.permission_list.includes(0)) {
                isShowSuperAdminTips.value = true
            }
        }

        async function getPermissionsetList() {
            // try {
            //     const result = await $fetch.post({
            //         url: '/shop/getpermissionsetlist'
            //     })
            //     console.log('员工权限集', result)
            //     permissionSet.value = result.permission_set
            //     roleNameMap.value = permissionSet.value.map((item: PermissionSetInterface) => item.name)
            //     selectOptions.value = permissionSet.value.map((item: PermissionSetInterface) => ({
            //         label: item.name,
            //         value: item.id
            //     })).filter((item) => item.label !== '超级管理员')

            //     return result
            // } catch (e) {
            //     openMessage("error", e.message || '获取权限集失败')
            // }
        }

        async function getStaffInfo() {
            try {
                if (props.staffId === store.state.shop.staffInfo.id) {
                    await store.dispatch('shop/getAndSetStaffInfo')
                }
                const result = await $fetch.post({
                    url: '/staff/getstaffinfo',
                    params: {
                        staff_id: props.staffId
                    }
                })
                console.log('员工详情', result)
                curStaffInfo.value = result
                staffInfoForm.value = {
                    realname: result.user.realname,
                    phone: result.user.phone,
                    birthday: result.user.birthday,
                    position: result.position,
                    entry_date: result.entry_date,
                    remarks: result.remarks,
                    weixinInfo: result.user
                }
                if (result.permission_set && result.permission_set.id) {
                    selectedVal.value = initSelectedVal = result.permission_set.id
                    permissionList.value = result.permission_set.permission_list
                }

                return result
            } catch (e) {
                openMessage("error", e.message || '获取员工详情失败')
            }
        }

        async function deleteClick() {
            try {
                if (props.staffId === store.state.shop.staffInfo.id) {
                    return openMessage('error', '不允许删除自己的员工角色')
                }
                if (!store.getters['shop/canIUse'](7)) {
                    return openMessage('error', '暂无删除员工权限，请联系超管开启')
                }
                const isConfirm = await openWarning({
                    title: '删除员工',
                    type: "danger",
                    render: (h) => (
                        <div>
                            <div class="fx-v-center fx-h-center" style="height: 20px; text-align: center; font-size: 14px; font-weight: 600; color: #333">确认删除员工&nbsp;<user-info userInfo={ staffInfoForm.value.weixinInfo } maxWidth={ '250px' }/>&nbsp;吗？</div>
                            <div style="margin-top: 8px; text-align: center; font-size: 12px; color: #666">删除后员工相关历史数据仍会保留</div>
                        </div>
                    )
                }).then(() => true).catch(() => false)
                if (isConfirm) {
                    isDeleteLoading.value = true
                    await $fetch.post({
                        url: '/staff/deletestaff',
                        params: {
                            staff_id: props.staffId
                        }
                    })
                    ctx.emit('update:visible', false)
                    openMessage('success', '删除成功')
                    props.deleteCallback && props.deleteCallback()
                }
            } catch (e) {
                openMessage("error", e.message || '删除失败')
            } finally {
                isDeleteLoading.value = false
            }
        }

        async function confirmClick() {
            try {
                isConfirmLoading.value = true
                if (props.mode === 'create') {
                    await editApplyStatus()
                    ctx.emit('update:visible', false)
                    openMessage('success', '添加员工成功')
                    props.confirmCallback && props.confirmCallback()
                }
                if (props.mode === 'update') {
                    await editStaffInfo()
                    ctx.emit('update:visible', false)
                    openMessage('success', '编辑员工成功')
                    props.confirmCallback && props.confirmCallback()
                    if (props.staffId === store.state.shop.staffInfo.id) {
                        try {
                            await store.dispatch('shop/getAndSetStaffInfo')
                        } catch (e) {
                            openMessage('error', e.message || '获取员工信息失败')
                        }
                    }
                }
            } catch (e) {
                if (props.mode === 'create') {
                    openMessage("error", e.message || '添加员工失败')
                }
                if (props.mode === 'update') {
                    openMessage("error", e.message || '编辑员工失败')
                }
            } finally {
                isConfirmLoading.value = false
            }
        }

        async function editStaffInfo() {
            const params = {
                staff_id: props.staffId,
                position: staffInfoForm.value.position || undefined,
                entry_date: staffInfoForm.value.entry_date || undefined,
                remarks: staffInfoForm.value.remarks || undefined,
                // permission_set_id: selectedVal.value || undefined
            }
            const result = await $fetch.post({
                url: '/staff/editstaffinfo',
                params
            })
            return result
        }

        async function editApplyStatus() {
            const result = await $fetch.post({
                url: '/staff/staffapplicationpass',
                params: {
                    staff_application_record_id: props.applyInfo.id,
                    position: staffInfoForm.value.position || undefined,
                    entry_date: staffInfoForm.value.entry_date || undefined,
                    remarks: staffInfoForm.value.remarks || undefined,
                    permission_list: [],  // PC端 暂时先写成空数组，具体逻辑参考移动端
                    // permission_set_id: selectedVal.value || undefined
                }
            })
            return result
        }

        return {
            // data
            isShowRolePermission,
            isShowEditAndAddStaffRole,
            isLoading,
            isDeleteLoading,
            isConfirmLoading,
            isCanNotEditSuperPermission,
            isShowSuperAdminTips,
            staffInfoForm,
            permissionList,
            selectOptions,
            selectedVal,
            roleNameMap,
            curRoleInfo,
            // computed
            headerTitle,
            formatEntryTime,
            canConfirm,
            // methods
            deleteClick,
            confirmClick,
            addRole,
            elSelectChange,
            elSelectClick
        }
    },
    components: {
        SideContainer,
        RolePermission,
        EditAndAddStaffRole
    }
})
</script>

<style lang="scss" scoped>
.body {
    padding: 20px 12px;
    font-size: 14px;
    color: #333;

    ::v-deep div[class^='el-input'] .el-input__inner {
        padding: 0 8px;
    }

    .title {
        font-weight: 600;
        margin-bottom: 12px;

        &:not(:first-of-type) {
            margin-top: 20px;
        }
    }

    .info-wrapper {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 8px;

        .info-item {
            display: flex;
            align-items: center;

            span {
                display: inline-block;
                height: 20px;
                line-height: 20px;

                &.des {
                    flex-shrink: 0;
                    width: 70px;
                }

                &.result {
                    width: 160px;
                }
            }

            ::v-deep .el-input {
                width: 160px;
            }
        }
    }

    .role-config,
    .role-permission {
        .des {
            flex-shrink: 0;
            width: 70px;
            line-height: 20px;
        }
    }

    .role-config {
        ::v-deep .el-input {
            width: 306px;
        }
    }

    .info-remark {
        display: flex;
        align-items: center;

        span.des {
            flex-shrink: 0;
            display: inline-block;
            height: 20px;
            line-height: 20px;
            width: 70px;
        }

        ::v-deep .el-input {
            flex-grow: 1;
        }
    }
}

.footer {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: 100%;
    height: 100%;
    padding: 7px 12px;

    .btn-wrapper.update {
        ::v-deep .el-button--danger {
            border: 1px solid #ddd !important;
            border-radius: 4px 0 0 4px !important;
        }

        ::v-deep .el-button--primary {
            margin-left: 0;
            border-radius: 0 4px 4px 0 !important;
        }
    }
}
</style>
